import Button from "components/common/Button";
import PrimeBadge from "components/common/PrimeBadge";
import useBottomSheet from "hooks/common/useBottomSheet";
import { useEffect, useRef, useState } from "react";
import { BJProfile } from "types/bjProfile";

const PrimeSwipeCall = () => {
    const { sheets, open, closeWithAnimation } = useBottomSheet();
    const sheet = sheets.PrimeSwipeCall;
    const { bjUid } = sheet.data;
    const MAX_COUNTDOWN = 10;
    const [countdown, setCountdown] = useState(0);
    const [bjUserInfo, setbjUserInfo] = useState<UserInfo | null>(null);
    const [bjBJProfile, setBjBJProfile] = useState<BJProfile | null>(null);
    const refCountdown = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const clear = () => {
            if (refCountdown.current) {
                clearInterval(refCountdown.current);
                refCountdown.current = null;
            }
        };

        refCountdown.current = setInterval(() => {
            if(countdown === -1) {
                clear();
                return;
            }

            if (countdown >= MAX_COUNTDOWN) {
                clear();
                closeWithAnimation(sheet.id, { data: 'timeout' });
                return;
            }

            setCountdown((prev) => prev + 0.1);
        }, 100);
        return () => {
            clear();
        };
        

    }, [countdown, sheet.id, MAX_COUNTDOWN, closeWithAnimation]);

    useEffect(() => {
        if (!bjUid) {
            return;
        }

        FriendsDataManager.getInfo(bjUid, (uid:string, profile:any) => {
            if (!uid) {
                return;
            }
            setbjUserInfo(profile);
        });

        PrimeDataManager.getBJProfile(bjUid, (err:string, profile:any) => {
            if (err) {
                return;
            }
            setBjBJProfile(profile);
        });
    },[bjUid]);

    const sendResult = (result: 'accept' | 'reject') => {
        RoomManager.chat('<psc>' + result);
        closeWithAnimation(sheet.id, { data: result });
    };

    const handleRequest = (result: 'accept' | 'reject') => {
        if(result === 'accept' && MyDataManager.getCoin() < (bjBJProfile?.cost ?? 0)) {
            RoomManager.chat('<psc>purchase');
            open('NeedCoin', { data: { productIds: ['ccoin_500', 'ccoin_1200'], showShopBtn: false, premiumProductId: 'ccoin_1200', body: brsc.sheet_low_coins_swipecall } }).then((purchaseResult) => {
                if(purchaseResult?.data) {
                    sendResult(result);

                    ba('primeswipecall', undefined, {
                        actionType: 'purchase',
                        productId: purchaseResult?.data?.productId,
                        guest: {
                            fbUid: myinfo.fbUid,
                            country: myinfo.country,
                            gender: myinfo.gender,
                        },
                        bj: {
                            fbUid: bjUserInfo?.fbUid,
                            country: bjUserInfo?.country,
                            gender: bjUserInfo?.gender,
                        },
                    });
                }
            });
            setCountdown(-1);
            return;
        }

        sendResult(result);
    };
  return <div className="flex flex-col justify-center items-center">
    <div className="typography-headline-md text-center text-dialog-txt-default">LOVE MATCH</div>
    <div className="typography-body-sm text-center text-dialog-txt-secondary">{brsc.sheet_swipecall_req}</div>
    <div className="relative flex rounded-xl overflow-hidden w-[50vw] h-[50vw] my-2">
        {bjUserInfo && <img className="w-full h-full object-cover" src={PhotoManager.getPrimePhotoURL(bjUserInfo, true)} alt="" />}
        {!bjUserInfo && <div className="w-full h-full bg-base-bg-subtle" />}
        {bjUserInfo && <div className="absolute start-0 bottom-2 flex gap-1 items-center justify-center text-center w-full text-base-txt-white">
            {<img className="flag" width="24" height="16" src={`/images/nation_flag/${bjUserInfo.country.toLowerCase()}.svg`} alt="" />}
            {<div className="typography-headline-sm">{bjUserInfo.nick}</div>}
        </div>}
    </div>
    <PrimeBadge cost={bjBJProfile?.cost ?? 0} perSecond={10} />
    <div className="mt-4 flex w-full justify-center gap-2 h-[64px]">
        <Button 
            onClick={() => handleRequest('reject')} 
            className="w-fit flex-none px-4" 
            style={{ text: '', icon: { name: '/icon/ic_close.svg', size: 32, color: 'filter-base-ic-primary' }, color: 'btn-bg-normal', borderRadius: 'lg' }}
        />
        <Button 
            onClick={()=> handleRequest('accept')} 
            className="flex-1" 
            style={{ 
                text: brsc.request_accept, 
                timer: { current: countdown, duration: MAX_COUNTDOWN, size: 24, color: 'var(--bcs-semantic-base-bg-focus)', backgroundColor: 'rgba(255, 255, 255, 0.20)' }, 
                color: 'btn-bg-primary', 
                fontColor: 'btn-txt-primary', 
                borderRadius: 'lg' 
            }}
        />
      </div>
  </div>;
};

export default PrimeSwipeCall;